export default {
  setSegments: function setSegments(state, segments) {
    state.segments = segments;
  },
  setSegmentEdit: function setSegmentEdit(state, segment) {
    state.segment_edit = segment;
  },
  setAudienceEdit: function setAudienceEdit(state, audience) {
    state.audience_edit = audience;
  },
  setCouponsEdit: function setCouponsEdit(state, audience) {
    state.coupons_edit = audience;
  },
  setSegmentNew: function setSegmentNew(state, segment) {
    state.segment_new = segment;
  },
  setCouponsNew: function setCouponsNew(state, coupons) {
    state.coupons_new = coupons;
  },
  setAudienceHelper: function setAudienceHelper(state, helper) {
    state.audience_helper = helper;
  },
  setCouponsHelper: function setCouponsHelper(state, helper) {
    state.coupons_helper = helper;
  },
  setSegmentHelper: function setSegmentHelper(state, helper) {
    state.segment_helper = helper;
  },
  setRequestDataActive: function setRequestDataActive(state, data) {
    state.request_data_active = data;
  },
  setShareAction: function setShareAction(state, data) {
    state.share_action = data;
  },
  setGptImages: function setGptImages(state, data) {
    state.gpt_images = data;
  },
  setAudienceImages: function setAudienceImages(state, data) {
    state.audience_images[data.key] = data.value;
  },
  setHasTalononeCoupons: function setHasTalononeCoupons(state, payload) {
    state.has_talonone_coupons = payload;
  },
  setRetailPurchasePrediction: function setRetailPurchasePrediction(state, payload) {
    state.retail_purchase_prediction = payload;
  },
  setHasEditSegment: function setHasEditSegment(state, payload) {
    state.has_edit_segment = payload;
  },
  setHasEditAudienceTypeGoogleAds: function setHasEditAudienceTypeGoogleAds(state, payload) {
    state.has_edit_audience_type_google = payload;
  }
};